import { FC } from 'react';
import s from './willBeSoon.module.scss';
import { useTranslation } from '@hooks/useTranslation';
import { SpriteIcon } from '@components/Sprites/SpriteIcon';
interface Props {}
export const WillBeSoon: FC<Props> = ({}) => {
  const {
    translate: tr
  } = useTranslation();
  return <div className={s.willBeSoon} data-sentry-component="WillBeSoon" data-sentry-source-file="WillBeSoon.tsx">
            <div className={s.willBeSoon__body}>
                <SpriteIcon name={'coming_soon'} colored width={232} height={232} data-sentry-element="SpriteIcon" data-sentry-source-file="WillBeSoon.tsx" />
                <div className={s.willBeSoon__text}>
                    {tr({
          id: 'payments.pages.history.will.be.soon'
        })}
                </div>
            </div>
        </div>;
};